import { apiPath } from "api";

export const twofaService = {
  sendOtp,
  verifyOtp,
  updatePhone,
};

function sendOtp(preAuthToken) {
  return fetch(apiPath.twoFaSendOtp, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ preAuthToken }),
  }).then(handleResponse);
}

function verifyOtp(preAuthToken, otpCode) {
  return fetch(apiPath.twoFaVerifyOtp, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ preAuthToken, otpCode }),
  }).then(handleResponse);
}

function updatePhone(preAuthToken, phoneCode, phoneNumber) {
  return fetch(apiPath.twoFaUpdatePhone, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ preAuthToken, phoneCode, phoneNumber }),
  }).then(handleResponse);
}

function handleResponse(response) {
  return response.json().then((data) => {
    if (!response.ok) {
      return Promise.reject(data);
    }
    return data;
  });
}
